import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { commonService } from "../../Network/services/commonService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";

import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import Modal from "react-modal";
import { TruncatedText } from "../../utils/textTruncation";
import ShareJob from "../ShareJob";
import PlanChip from "../PlanChip";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

const MyContractsView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [profile, setProfile] = useState({});
  const [name, setName] = useState("");
  const [postedJobList, setPostedJobList] = useState([]);
  const [awardedJoblist, setAwardedJoblist] = useState([]);
  const [postJobErrormsg, setpostJobErrormsg] = useState("");
  const [awardedJobErrormsg, setawardedJobErrormsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [openShareJob, setOpenSharejob] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  
  const [postedJobsLoading, setPostedJobsLoading] = useState(false);
  const [awardedJobsLoading, setAwardedJobsLoading] = useState(false);

  const [commonSearch, setCommonSearch] = useState("");
  
  const [allPostedJobs, setAllPostedJobs] = useState([]);
  const [allAwardedJobs, setAllAwardedJobs] = useState([]);

  const commonSearchDebounceRef = useRef(null);

  const applyCommonFilter = useCallback((jobsData, searchTerm) => {
    if (!searchTerm || searchTerm.trim() === '') {
      return jobsData; 
    }
    
    const searchLower = searchTerm.toLowerCase();
    return jobsData.filter(job => 
      job.job_title?.toLowerCase().includes(searchLower) ||
      job.job_description?.toLowerCase().includes(searchLower) ||
      job.skills?.toLowerCase().includes(searchLower) ||
      job.job_location?.toLowerCase().includes(searchLower) ||
      job.category_full_name?.toLowerCase().includes(searchLower) ||
      job.parent_category_name?.toLowerCase().includes(searchLower) ||
      job.job_unique_id?.toLowerCase().includes(searchLower)
    );
  }, []);

  const debouncedCommonSearch = useCallback((searchTerm) => {
    if (commonSearchDebounceRef.current) {
      clearTimeout(commonSearchDebounceRef.current);
    }
    
    commonSearchDebounceRef.current = setTimeout(() => {
      const filteredPosted = applyCommonFilter(allPostedJobs, searchTerm);
      const filteredAwarded = applyCommonFilter(allAwardedJobs, searchTerm);
      
      setPostedJobList(filteredPosted);
      setAwardedJoblist(filteredAwarded);
    }, 500); 
  }, [allPostedJobs, allAwardedJobs, applyCommonFilter]);

  useEffect(() => {
    debouncedCommonSearch(commonSearch);
    
    return () => {
      if (commonSearchDebounceRef.current) {
        clearTimeout(commonSearchDebounceRef.current);
      }
    };
  }, [commonSearch, debouncedCommonSearch]);

  useEffect(() => {
    
    let user = JSON.parse(window.localStorage.getItem("UserData"));

    getQuoteList();
    setName(user.first_name + " " + user.last_name);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const redirect = () => {
    history.push("/ExperienceUpdate");
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  
  const getQuoteList = () => {
    setPostedJobsLoading(true);

    const FormData = require("form-data");

    const form = new FormData();

    commonService
      .CommonService("my_contracts", form)
      .then(async (res) => {
        if (res.status == 200) {
          setPostedJobList(res.data);
          setAllPostedJobs(res.data); 
        } else {
          setpostJobErrormsg(res.message)
        }
      })
      .catch((err) => {
        setpostJobErrormsg("Something went wrong! please try again later!!")

      })
      .finally(() => {
        setPostedJobsLoading(false);
        getAwardedJobList();
      });
  };

  const getAwardedJobList = () => {
    setAwardedJobsLoading(true);

    const FormData = require("form-data");

    const form = new FormData();

    commonService
      .CommonService("awarded_projects", form)
      .then(async (res) => {
        if (res.status == 200) {
          setAwardedJoblist(res.data);
          setAllAwardedJobs(res.data); 
        } else {
          setawardedJobErrormsg(res.message)

        }
      })
      .catch((err) => {
        setawardedJobErrormsg("Something went wrong! please try again later!!")

      })
      .finally(() => {
        setAwardedJobsLoading(false);
      });
  };
  return (
    <section className="post submitted">
      <div className="container">
        <div className="banner paddimg-bottom">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <a href="/">
                      <i className="bx bx-chevron-left" /> Back to all jobs
                    </a>
                  </li>
                </ul>
                <div className="header-container">
                  <h1 className="quotes-title header-title">Jobs I posted</h1>
                  
                  <div className="search-container">
                    <div className="search-input-wrapper">
                      <img 
                        src="assets/images/SearchIcon.svg" 
                        alt="Search" 
                        className="search-icon"
                      />
                      <input
                        type="text"
                        placeholder="Search jobs..."
                        value={commonSearch}
                        onChange={(e) => {
                          setCommonSearch(e.target.value);
                        }}
                        className="search-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="quotes">
          <div className="tabset">
            <input
              type="radio"
              name="tabset"
              id="tab1"
              aria-controls="marzen"
              defaultChecked
            />
            <label htmlFor="tab1">Posted Jobs</label>
            <input
              type="radio"
              name="tabset"
              id="tab2"
              aria-controls="rauchbier"
            />
            <label htmlFor="tab2">Projects Awarded</label>
            <div className="tab-panels">
              <section id="marzen" className="tab-panel">
                {postedJobsLoading ? (
                  <div className="job-loading-spinner">
                    <div className="job-spinner"></div>
                  </div>
                ) : !postedJobList.length > 0 ? (
                  <div className="no-jobs-message">
                    <div className="no-jobs-icon">📋</div>
                    <h3>No Posted Jobs Found</h3>
                    <p>{postJobErrormsg || "You haven't posted any jobs yet."}</p>
                  </div>
                ) : (
                  <LoadingOverlay>
                    {postedJobList.map((item) => (
                    <div key={item.id} className="post-list">
                      <Link className="job-link" style={{width: "100%"}} to={{ pathname: `/requestlist/${item.id}/`, state: { item } }}>
                        <div className="plan-meta-row">
                          <div className="plan-chip-container">
                            {item.job_plan && <PlanChip jobPlan={item.job_plan} idRequired={true} />}
                          </div>
                          <div className="job-meta">
                            <span className="job-id">Job ID: {item.job_unique_id?.replace('Job# ', '') || item.id}</span>
                            <span className="job-location">• <TruncatedText text={item.job_location} maxLength={50} /></span>
                            <span className="share-icon" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedJob(item); setOpenSharejob(true); }}><img src="/assets/images/ShareIcon.svg" /></span>
                          </div>
                        </div>

                        <div className="category-skills-row">
                          <div className="job-category">
                            {item.parent_category_name && item.category_full_name 
                              ? `${item.parent_category_name} > ${item.category_full_name}`
                              : item.category_full_name || item.category || 'General'}
                          </div>
                          {item.skills && (
                            <div className="job-title-skills">
                              {item.skills.split(',').map((skill, index) => (
                                <span key={index} className="skill-tag">
                                  {skill.trim()}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>

                        <h1 className="job-title">
                          <TruncatedText 
                            text={item.job_title} 
                            maxLength={50} 
                            className="job-title-text" 
                          />
                        </h1>


                        <div className="payment-info">
                          <div className="payment-amount">
                            ₹{item.amount}
                          </div>
                          <div className="payment-details">
                            {item.payment_term} | {item.timestamp}
                          </div>
                        </div>


                        <div className="job-footer">
                          <div className="target-date">
                            Target Close Date: {item.target_closed_date}
                          </div>
                          <div className="quotes-count">
                            {item.total_quote_count || 0} Quotes received
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                  <Loader loading={loading} />
                </LoadingOverlay>
                )}
              </section>
              <section id="rauchbier" className="tab-panel">
                {awardedJobsLoading ? (
                  <div className="job-loading-spinner">
                    <div className="job-spinner"></div>
                  </div>
                ) : !awardedJoblist.length > 0 ? (
                  <div className="no-jobs-message">
                    <div className="no-jobs-icon">📋</div>
                    <h3>No Awarded Projects Found</h3>
                    <p>{awardedJobErrormsg || "You haven't been awarded any projects yet."}</p>
                  </div>
                ) : (
                  <LoadingOverlay>
                  {awardedJoblist.map((item) => (
                    <div key={item.id} className="post-list">
                      <Link className="job-link" style={{width: "100%"}} to={{ pathname: `/awardedjob/${item.id}/`, state: { item } }}>
                        <div className="plan-meta-row">
                          <div className="plan-chip-container">
                            {item.job_plan && <PlanChip jobPlan={item.job_plan} idRequired={true} />}
                          </div>
                          {item.completed_status === "Completed" && <div className="job-completed-chip">
                            <span>Completed</span>
                          </div>}
                          <div className="job-meta">
                            <span className="job-id">Job ID: {item.job_unique_id?.replace('Job# ', '') || item.id}</span>
                            <span className="job-location">• <TruncatedText text={item.job_location} maxLength={50} /></span>
                            <span className="share-icon" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedJob(item); setOpenSharejob(true); }}><img src="/assets/images/ShareIcon.svg" /></span>
                          </div>
                        </div>

                        <div className="category-skills-row">
                          <div className="job-category">
                            {item.parent_category_name && item.category_full_name 
                              ? `${item.parent_category_name} > ${item.category_full_name}`
                              : item.category_full_name || item.category || 'General'}
                          </div>
                          {item.skills && (
                            <div className="job-title-skills">
                              {item.job_skills_db.split(',').map((skill, index) => (
                                <span key={index} className="skill-tag">
                                  {skill.trim()}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>

                        <h1 className="job-title">
                          <TruncatedText 
                            text={item.job_title} 
                            maxLength={50} 
                            className="job-title-text" 
                          />
                        </h1>

 

                        <div className="payment-info">
                          <div className="payment-amount">
                            ₹{item.amount}
                          </div>
                          <div className="payment-details">
                            {item.payment_term} | {item.timestamp}
                          </div>
                        </div>


                        <div className="job-footer">
                          <div className="target-date">
                            Target Close Date: {item.target_closed_date}
                          </div>
                          
                        </div>
                      </Link>
                    </div>
                  ))}
                  <Loader loading={loading} />
                </LoadingOverlay>
                )}
              </section>
            </div>
          </div>
        </div>
      </div>
      <ShareJob 
        isOpen={openShareJob} 
        toggle={() => setOpenSharejob(false)} 
        jobData={selectedJob}
      />
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyContractsView);
